const MAX_MANDATE_REFERENCE_LENGTH = 35;

export {
  MAX_MANDATE_REFERENCE_LENGTH
}
